"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductWizardInputType = exports.ProductWizardFlowType = void 0;
var ProductWizardFlowType;
(function (ProductWizardFlowType) {
    ProductWizardFlowType["MULTIPLE"] = "multiple";
    ProductWizardFlowType["LINEAR"] = "linear";
})(ProductWizardFlowType || (exports.ProductWizardFlowType = ProductWizardFlowType = {}));
var ProductWizardInputType;
(function (ProductWizardInputType) {
    ProductWizardInputType["CHECKBOX"] = "checkbox";
    ProductWizardInputType["RADIO"] = "radio";
})(ProductWizardInputType || (exports.ProductWizardInputType = ProductWizardInputType = {}));
//# sourceMappingURL=ProductWizardTypes.js.map